import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import { HomeThreeComponent } from './components/pages/home-three/home-three.component';
import { HomeFourComponent } from './components/pages/home-four/home-four.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { OurTeamComponent } from './components/pages/our-team/our-team.component';
import { TestimonialsComponent } from './components/pages/testimonials/testimonials.component';
import { PricingTableComponent } from './components/pages/pricing-table/pricing-table.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { PortfolioTwoColumnComponent } from './components/pages/portfolio-one/portfolio-one.component';
import { PortfolioThreeColumnComponent } from './components/pages/portfolio-two/portfolio-two.component';
import { PortfolioFourColumnComponent } from './components/pages/portfolio-three/portfolio-three.component';
import { BlogGridComponent } from './components/pages/blog-grid/blog-grid.component';
import { BlogStandardComponent } from './components/pages/blog-standard/blog-standard.component';
import { ContactComponent } from './components/pages/contact/contact.component';

const routes: Routes = [
  {path: '', component: HomeOneComponent},
  {path: 'home-two', component: HomeTwoComponent},
  {path: 'home-three', component: HomeThreeComponent},
  {path: 'home-four', component: HomeFourComponent},
  {path: 'about-us', component: AboutUsComponent},
  {path: 'our-team', component: OurTeamComponent},
  {path: 'testimonials', component: TestimonialsComponent},
  {path: 'pricing-table', component: PricingTableComponent},
  {path: 'coming-soon', component: ComingSoonComponent},
  {path: 'services', component: ServicesComponent},
  {path: 'portfolio-one', component: PortfolioTwoColumnComponent},
  {path: 'portfolio-two', component: PortfolioThreeColumnComponent},
  {path: 'portfolio-three', component: PortfolioFourColumnComponent},
  {path: 'blog-grid', component: BlogGridComponent},
  {path: 'blog-standard', component: BlogStandardComponent},
  {path: 'contact', component: ContactComponent},
  // Here add new pages component

  {path: '**', component: ErrorComponent} // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
